import { SKUS } from '@/constants';
import { Sku } from '@/types';
import { toCamelCase } from '@/utils/skutype';

interface SkuElementProps {
  sku: Sku;
  selectedSku: Sku;
  handleSkuChange: (event: any) => void;
}

export default function SkuElement({ sku, selectedSku, handleSkuChange }: SkuElementProps) {
  return (
    <label
      key={sku.skuID}
      className={`h-15 md:text-md relative basis-48 cursor-pointer border border-solid border-gray-300 px-3 py-5 text-center font-medium first:rounded-l-3xl last:rounded-r-3xl md:px-10 md:py-5 ${
        selectedSku.skuID === sku.skuID &&
        "md:before:top-center border-blue-500 bg-slate-200 md:before:absolute md:before:left-3 md:before:content-['✔️']"
      }`}
    >
      {toCamelCase(sku.shortName)}
      <input
        key={sku.skuID}
        autoFocus={sku.skuID === SKUS.WHOLE_BODY}
        type="radio"
        name="sku"
        value={sku.skuID}
        className="hidden"
        onChange={handleSkuChange}
      />
    </label>
  );
}
